import { put, select, takeLatest } from 'redux-saga/effects'
import { getHomeSelector } from '../selectors/getHome.selector'
import { setCompleteFilter } from '../store/home.actions'
import { HomeConstants } from '../store/home.constants'
import { IHomeState } from '../store/home.types'

export function* completeStatusFilter() {
  const state: IHomeState = yield select(getHomeSelector)
  const { pcrDocs, filter } = state
  const { completeFilterOn, incompleteFilterOn, needsReviewFilterOn } = filter
  const filters: string[] = []
  incompleteFilterOn && filters.push('Incomplete')
  needsReviewFilterOn && filters.push('Needs Review')
  const showClearFiltersButton = !completeFilterOn || needsReviewFilterOn || incompleteFilterOn
  if (completeFilterOn) {
    if (filters && filters.length) {
      const filteredPCRDocs = pcrDocs.filter((pcrDoc) => filters.indexOf(pcrDoc.status) > -1)
      yield put(setCompleteFilter(filteredPCRDocs, showClearFiltersButton))
    } else {
      yield put(setCompleteFilter(pcrDocs, showClearFiltersButton))
    }
  } else {
    const filteredPCRDocs = state.pcrDocs.filter(
      (pcrDoc) => pcrDoc.status === 'Complete' || filters.indexOf(pcrDoc.status) > -1
    )
    yield put(setCompleteFilter(filteredPCRDocs, showClearFiltersButton))
  }
}

export function* completeStatusFilterSaga() {
  yield takeLatest([HomeConstants.FILTER_COMPLETE], completeStatusFilter)
}
